<template>
    <div class="content-wraper login-register-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-12  col-md-6 col-sm-12">
                    <div class="customer-login-register">
                        <h3>Registeren</h3>
                        <div>
                            <p>Voeg hieronder je contactgegevens toe om materiaal te kunnen aanvragen en lenen. Kies ook een gebruikersnaam en wachtwoord. Hiermee kun je de volgende keer op uitleendiensterfgoed.be inloggen.</p>
                            <p>
                                Je persoonlijke gegevens worden beheerd volgens het <a href="https://faro.be/privacybeleid">Privacybeleid van FARO</a>. Ze worden alleen gebruikt om onze dienstverlening aan jou zo vlot mogelijk te organiseren.
                                Dit houdt in dat we de gegevens delen met de partnerorganisaties die een uitleenpunt bemannen.
                                Je kunt je persoonlijke gegevens op elk moment inkijken, bewerken en verwijderen, nadat je bent ingelogd.
                                Of je kunt een aanvraag richten aan <a href="mailto:uitleendienst@faro.be">uitleendienst@faro.be</a>.
                            </p>
                        </div>
                        <div class="login-Register-info">
                            <!-- <div class="form-group">
                                <label>Gebruikersnaam <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" name="userName" v-model="userName"
                                :class="validateInput(this.userName, /[0-9a-zA-Z]{2,250}/)"
                                maxlength="50">
                            </div> -->
                            <div class="form-group">
                                <label>E-mailadres <span class="text-danger">*</span></label>
                                <input
                                v-model="email"
                                :class="validateInput(email, /([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)/)"
                                class="form-control"
                                type="text"
                                name="email"
                                maxlength="256">
                            </div>
                            <passwordfield
                                v-model="password"
                                name="Wachtwoord"
                                required="true"/>
                            <div class="form-group">
                                <label>Herhaal wachtwoord <span class="text-danger">*</span></label>
                                <input
                                :class="validateConfirmPassword"
                                v-model="confirmPassword"
                                type="password"
                                name="confirmPassword"
                                autocomplete="new-password"
                                class="form-control">
                            </div>

                            <div class="form-group">
                                <label>Organisatie</label>
                                <input
                                v-model="companyName"
                                :class="validateInput(firstName, /[a-zA-Z]{2,50}/)"
                                class="form-control"
                                type="text"
                                name="companyName"
                                maxlength="50">
                            </div>

                            <div class="form-group">
                              <label>Ondernemingsnummer</label>
                              <input
                                v-model="number"
                                :class="validateInput(number, /[0-9a-zA-Z]{2,250}/)"
                                class="form-control"
                                type="text"
                                name="number"
                                maxlength="250">
                              <br>
                            </div>
                            <div class="form-group">
                                <label>Initialen <span class="text-danger">*</span></label>
                                <select
                                v-model="salutation"
                                class="form-control"
                                name="initials"
                                autocomplete="initials">
                                    <option value="Mr">Dhr.</option>
                                    <option value="Mrs">Mvr.</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Voornaam <span class="text-danger">*</span></label>
                                <input
                                v-model="firstName"
                                :class="validateInput(firstName, /[a-zA-Z]{2,50}/)"
                                class="form-control"
                                type="text"
                                name="firstName"
                                maxlength="50">
                            </div>
                            <div class="form-group">
                                <label>Achternaam <span class="text-danger">*</span></label>
                                <input
                                v-model="lastName"
                                :class="validateInput(lastName, /[a-zA-Z]{2,50}/)"
                                class="form-control"
                                type="text"
                                name="lastName"
                                maxlength="50">
                            </div>

                            <div class="form-group">
                                <label>Telefoonnummer</label>
                                <input
                                v-model="tel"
                                class="form-control"
                                type="text"
                                name="tel"
                                maxlength="15">
                            </div>
                            <div class="form-group">
                                <label>Straat</label>
                                <input
                                v-model="street"
                                class="form-control"
                                type="text"
                                name="street"
                                maxlength="50">
                            </div>
                            <div class="form-group">
                                <label>Huisnummer</label>
                                <input
                                v-model="houseNumber"
                                class="form-control"
                                type="text"
                                name="houseNumber"
                                maxlength="10">
                            </div>
                            <div class="form-group">
                                <label>Toevoeging</label>
                                <input
                                v-model="houseNumberAddition"
                                class="form-control"
                                type="text"
                                name="houseNumberAddition"
                                maxlength="10">
                            </div>
                            <div class="form-group">
                                <label>Postcode</label>
                                <input
                                v-model="zipCode"
                                class="form-control"
                                type="text"
                                name="zipCode"
                                maxlength="10">
                            </div>
                            <div class="form-group">
                                <label>Plaats</label>
                                <input
                                v-model="city"
                                class="form-control"
                                type="text"
                                name="city"
                                maxlength="10">
                            </div>
                            <div class="form-group">
                                <label>Taal</label>
                                <select
                                v-model="languageID"
                                class="form-control"
                                name="language"
                                autocomplete="language">
                                    <option
                                    selected
                                    value="NL">Nederlands</option>
                                    <option value="EN">English</option>
                                    <option value="FR">Français</option>
                                </select>
                            </div>
                            <div>
                                <p>Nadat je op onderstaande knop drukt, ontvang je automatisch een e-mail om je gebruikersprofiel te bevestigen. Kijk zeker je ongewenste e-mail na, wanneer er niets in je mailbox verschijnt.</p>
                            </div>
                            <div class="form-group">
                                <button
                                value="Registreer"
                                name="registreer"
                                class="button-login"
                                @click="register()">
                                    Registreer
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {BTable} from 'bootstrap-vue'
import AuthorizationService from '@/services/AuthorizationService.js'
import passwordfield from '../Global/Passwordfield'
import swal from 'sweetalert'

require('moment/locale/nl')
require('vue-moment')

export default {
    components: {
        BTable,
        passwordfield
    },
    data () {
        return {
            // userName: '',
            languageID: 'NL',
            email: '',
            password: '',
            confirmPassword: '',

            companyName: '',
            salutation: 'Mr',
            firstName: '',
            lastName: '',
            number: '',
            numberType: 'Ondernemingsnummer',

            tel: '',
            street: '',
            houseNumber: '',
            houseNumberAddition: '',
            city: '',
            zipCode: ''
        }
    },
    computed: {
        validateConfirmPassword: function () {
            if (this.confirmPassword > 0) {
                return this.confirmPassword.length && this.password === this.confirmPassword ? 'is-valid' : 'is-invalid'
            } else {
                return ''
            }
        }
    },
    methods: {
        validateInput: function (inputModel, pattern) {
            if (inputModel.length > 0) {
                return pattern.test(inputModel) ? 'is-valid' : 'is-invalid'
            } else {
                return ''
            }
        },
        async register () {
            let user = {
                ReceiverName: this.firstName,
                UserName: this.email,
                LanguageID: this.languageID,
                Email: this.email,
                Password: this.password,
                ConfirmPassword: this.confirmPassword,

                CompanyName: this.companyName,
                Salutation: this.salutation,
                FirstName: this.firstName,
                LastName: this.lastName,
                ECCUST_Ondernemingsnummer: this.number,

                Tel: this.tel,
                Street: this.street,
                HouseNumber: this.houseNumber,
                HouseNumberAddition: this.houseNumberAddition,
                ZipCode: this.zipCode,
                City: this.city,
                CountryID: 'BE'
            }

            if (user.CompanyName === '') {
                user.CompanyName = user.FirstName + ' ' + user.LastName
            }

            try {
                let result = await AuthorizationService.register(user)
                if (result.ExceptionLevel) {
                    if (result.ExceptionLevel === 'SUCCESS') {
                        this.$router.push({name: 'login'})
                    }
                    swal('', result.Message, result.ExceptionLevel.toLowerCase())
                }
            } catch (error) {
                this.$router.push({name: 'InternalError'})
            }
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/Authentication/Register.vue